<template>
  <v-container>
    <!-- Titulo quemado de Procuraduría  -->
    <!-- HERO (como la imagen) -->
    <section class="hero">
      <!-- background/patrón (tú pones la imagen) -->
      <div class="hero-bg"></div>

      <div class="hero-inner">
        <!-- Columna izquierda -->
        <div class="hero-left">
          <h1 class="hero-title">
            Procuraduría General de<br/>
            Justicia del Estado de Hidalgo
          </h1>

          <p class="hero-sub">
            Plataforma de acceso a los trámites y servicios
          </p>

          <v-btn class="hero-btn" @click="redirigirDenuncia">
            DENUNCIA EN LÍNEA
          </v-btn>
        </div>

        <!-- Columna derecha (placeholder de imagen) -->
        <div class="hero-right">
          <div class="hero-capsule">
            <!-- Solo placeholder, tú pones la imagen -->
            <img
              :src="tabletImg"
              alt="Tablet"
              class="hero-photo"
            />

          </div>
        </div>
      </div>
    </section>


    <v-row class="mt-5">
      <v-col>
        <h2 class="text-h6 font-weight-bold">Servicios</h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col v-for="(service, index) in services" :key="index" cols="12" sm="6" md="4">
        <!-- -->
        <v-card class="card">
          <span class="tag-card">Denuncia</span>
          <p class="text-card">{{ service.name }}</p>

          <v-btn class="text-none button_card" @click="handleClick(service.name)">
            <v-icon size="18" color="white">mdi-chevron-right</v-icon>
          </v-btn>
        </v-card>

      </v-col>
    </v-row>

    <div style="margin-top: 10rem;">
      <h2 class="text-h6 font-weight-bold">Centro de Atención Temprana</h2>
    </div>


    <!-- Mapa con Leaflet -->
    <div class="map-wrap">
      <div class="map-card">
        <div class="map-card-text">
          <center>
            <v-icon color="#6b1230" size="40">mdi-map-marker</v-icon>
          </center>
          <br>
          <div class="map-card-title text-center">
            Procuraduría General de Justicia del Estado de Hidalgo
          </div>
          <div class="map-card-sub text-center">
            Mapa interactivo de ubicación
          </div>
        </div>
      </div>

      <div id="map"></div>
    </div>


  </v-container>
</template>

<script>
import L from "leaflet"; // Importar Leaflet
import "leaflet-control-geocoder";
import {loginRedirect} from "@/store/keycloak";


export default {
  computed: {
    tabletImg() {
      return require('@/assets/img/tablet_logo.png')
    }
  },
  data() {
    return {
      services: [
        {name: "Expedición de Constancia de No Antecedentes Penales"},
        {name: "Inicio de carpetas de investigación"},
        {name: "Constancia de vehículo no robado"},
        {name: "Devolución de vehículos recuperados"},
        {name: "Atención ciudadana y recepción de quejas o denuncias"},
        {name: "Análisis de identificación de metabolitos de abuso de drogas en muestras de orina"},
        {name: "Mediación y conciliación en materia penal"},
        {name: "Alerta Amber"},
        {name: "Extravio de documentos Placas estatales"},
        {name: "Extravio de documentos Credenciales"},
        {name: "Extravio de documentos Tenencia de armas"},
        {name: "Extravio de documentos Título de propiedad"},
        {name: "Extravio de documentos Certificado parcelario"},
        {name: "Extravio de documentos Testimonio de escritura"},
        {name: "Extravio de documentos Certificado de estudios"},
        {name: "Extravio de documentos Certificado de plan de estudios"},
        {name: "Extravio de documentos Título universitario"},
        {name: "Extravio de documentos Cédula profesional de licenciatura"},
        {name: "Extravio de documentos Cédula profesional de maestría"},
        {name: "Extravio de documentos Pasaporte mexicano"},
        {name: "Extravio de documentos Visa mexicana"},
        {name: "Extravio de documentos Cédula profesional de licenciatura"},
        {name: "Extravio de documentos Justicia cívica"},
        {name: "Extravio de documentos FGR por disposición de dinero en tarjetas"}
      ],

    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    handleClick() {
      loginRedirect();
    },
    initMap() {
      this.map = L.map("map", {
        scrollWheelZoom: false,  // ✅ como páginas institucionales
        zoomControl: true
      }).setView([20.0639879, -98.783259], 14);

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(this.map);

      // Definir icono personalizado
      const customIcon = L.icon({
        //iconUrl: require("../assets/icons/procu.png"), // Asegúrate de que el icono esté en la carpeta assets
        iconSize: [40, 40],
        iconAnchor: [20, 40],
        popupAnchor: [0, -40]
      });

      // Agregar marcador con icono personalizado
      L.marker([20.0911, -98.7624], {icon: customIcon})
        .addTo(this.map)
        .bindPopup("Procuraduría General de Justicia del Estado de Hidalgo")
        .openPopup();

      // Agregar control de búsqueda
      L.Control.geocoder({
        defaultMarkGeocode: false,
        placeholder: "Buscar estado..."
      })
        .on("markgeocode", (e) => {
          const latlng = e.geocode.center;
          this.map.setView(latlng, 7);
        })
        .addTo(this.map);
    }
    ,


    redirigirDenuncia() {
      window.open("https://denuncia.pgjhidalgo.gob.mx/", "_blank");
    }
  }
};
</script>

<style scoped>
.map-wrap {
  position: relative;
  width: 100%;
  height: 520px;
  margin-top: 20px;
  border-radius: 22px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 16px 28px rgba(0, 0, 0, 0.12);
}

#map {
  width: 100%;
  height: 100%;
}

/* Tarjeta tipo “glass” */
.map-card {
  position: absolute;
  left: 24px;
  top: 24px;
  z-index: 500; /* arriba del mapa */

  width: 420px;
  max-width: calc(100% - 48px);
  padding: 18px 18px;

  border-radius: 18px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  border: 1px solid rgba(255, 255, 255, 0.55);
  box-shadow: 0 14px 26px rgba(0, 0, 0, 0.14);

  display: flex;
  gap: 12px;
  align-items: center;
}

.map-card-icon {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(107, 18, 48, 0.10);
  display: flex;
  align-items: center;
  justify-content: center;
}

.map-card-title {
  color: #6b1230;
  font-weight: 900;
  font-size: 18px;
}

.map-card-sub {
  margin-top: 6px;
  color: #6f6f6f;
  font-size: 13px;
}


@media (max-width: 1399px) {
  .text-left {
    width: 100% !important;
  }

}

/* Oculta el botón duplicado en escritorio */
.mobile-only {
  display: none;
}


/* Reestructura en pantallas pequeñas */
@media (max-width: 1199px) {
  .titulo-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .titulo {
    width: 100%;
    text-align: left;
  }

  .custom-button {
    display: none; /* Oculta el botón en la cabecera */
  }

  .mobile-only {
    display: inline-flex; /* Muestra el botón debajo del párrafo */
    margin-top: 0.5rem;
    min-width: 180px;
    max-width: 180px;
  }
}

/* HERO */
.hero {
  position: relative;
  margin-bottom: 34px;
  padding: 44px 0 30px;
  overflow: hidden;
}

/* Aquí tú pones el background/patrón */
.hero-bg {
  position: absolute;
  inset: 0;
  /* EJEMPLO (lo cambias tú):
     background-image: url('/img/tu_patron.svg');
  */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  opacity: 0.18;
  pointer-events: none;
}

.hero-inner {
  position: relative;
  display: grid;
  grid-template-columns: 1.15fr 0.85fr;
  align-items: center;
  gap: 24px;
}

.hero-left {
  max-width: 720px;
}

.hero-title {
  margin: 0;
  color: #6b1230; /* vino */
  font-weight: 900;
  font-size: 44px;
  line-height: 1.06;
}

.hero-sub {
  margin: 14px 0 0;
  color: #7a7a7a;
  font-size: 16px;
}

.hero-btn {
  margin-top: 20px;
  background: #265B4E !important; /* verde */
  color: #fff !important;
  font-weight: 800;
  letter-spacing: 0.4px;
  border-radius: 10px;
  height: 42px;
  padding: 0 18px;
}

/* Columna derecha */
.hero-right {
  display: flex;
  justify-content: flex-end;
}

/* Cápsula grande (fondo suave) */
.hero-capsule {
  width: 533.08px;
  height: 276.92px;
  border-radius: 999px;
  background: rgba(107, 18, 48, 0.16); /* vino tenue */
  display: flex;
  align-items: center;
  justify-content: center;
}


.hero-photo {
  width: 276.9px;
  height: 276.9px;
  border-radius: 29037460px;
  opacity: 1;
  left: 128px;
  border-width: 6.92px;
  object-fit: cover;
  background: #fff;
  border: 8px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.10);
}

.card {
  border-radius: 20px;
  padding: 10px;
  margin: 20px;
  width: 413.33px;
  height: 160px;
  box-shadow: 10px 5px 5px;
}

.card:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 24px rgba(0, 0, 0, 0.14);
}

.tag-card {
  background-color: rgba(98, 17, 50, 0.12);
  border-radius: 23px;
  border: solid #621132;
  padding: 5px;
  width: 75px;
  text-align: center;
  font-size: 10px;
  color: #621132;
}

.text-card {
  color: #621132;
  font-weight: 900;
  font-size: 16px;
  line-height: 1.06;
  text-align: justify;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 10px;
}

.button_card {
  position: absolute;
  right: 14px;
  bottom: 14px;

  width: 30px !important;
  height: 30px !important;
  padding: 0 !important;
  min-width: 30px !important;
  border-radius: 999px !important;

  display: flex !important;
  align-items: center;
  justify-content: center;

  background: #6b1230 !important;
  color: #fff !important;

  border: 0 !important;
  box-shadow: none !important;
  line-height: 0 !important;
}

/* Tamaño del icono dentro */
.button_card i,
.button_card .v-icon {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
}

/* Responsive */
@media (max-width: 1199px) {
  .hero-inner {
    grid-template-columns: 1fr;
  }

  .hero-right {
    justify-content: flex-start;
  }

  .hero-title {
    font-size: 36px;
  }

  .hero-capsule {
    width: 420px;
    height: 220px;
  }
}

@media (max-width: 600px) {
  .hero-title {
    font-size: 30px;
  }

  .hero-capsule {
    width: 340px;
    height: 200px;
  }

  .hero-photo-placeholder {
    width: 150px;
    height: 150px;
  }
}

.gov-footer {
  position: relative;
  color: rgba(255,255,255,.92);

  /* 1) El gradiente va primero (arriba) pero con alpha para que deje ver la imagen */
  /* 2) La imagen va abajo */
  background-image:
    linear-gradient(
      90deg,
      rgba(100, 18, 50, 0.88) 0%,
      rgba(131, 28, 63, 0.88) 100%
    ),
    url("/src/assets/img/footer-background.png");

  /* Cada capa se configura por separado (gradiente, imagen) */
  background-repeat: no-repeat, repeat;
  background-position: center, center;
  background-size: cover, 520px auto;
}

</style>
